import { useState } from 'react';

import BlogHeroSlide from '@klv/molecules/blog-hero-slide';
import CarouselButton from '@klv/molecules/carousel-button';
import SlideIndicator from '@klv/atoms/slide-indicator';

import { accentColorShouldBeLemon } from '@klv/molecules/blog-hero-slide/utils/functions';
import { useWindowDimensions } from '@klv/hooks/useWindowDimensions';
import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/blogHero.module.scss';

import type { IBlogHero } from './types';

const BlogHero = ({
  className,
  slides = [],
  ...props
}: IBlogHero) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const backgroundColor = slides[currentSlide]?.backgroundColor || 'cedar';
  const windowDimensions = useWindowDimensions();

  if (!slides.length) {
    return null;
  }

  return (
    <div
      className={generateClassName([className, styles.blogHero])}
      style={{ backgroundColor: `var(--color-${backgroundColor})` }}
      {...props}
    >
      <div className={generateClassName(['grid', styles.grid])}>
        <BlogHeroSlide
          controls={(slides?.length > 1) ? (
            <>
              <CarouselButton
                aria-label="Previous slide"
                className={generateClassName([styles.carouselButton, styles.left])}
                direction="left"
                onClick={() => setCurrentSlide(currentSlide > 0 ? currentSlide - 1 : slides.length - 1)}
              />
              <CarouselButton
                aria-label="Next slide"
                className={generateClassName([styles.carouselButton, styles.right])}
                direction="right"
                onClick={() => setCurrentSlide(currentSlide < (slides.length - 1) ? currentSlide + 1 : 0)}
              />
            </>
          ) : undefined}
          indicator={(slides?.length > 1) ? (
            <SlideIndicator
              className={styles.slideIndicator}
              currentSlide={currentSlide}
              indicatorColor={windowDimensions.width <= 576 ? 'poppy' : accentColorShouldBeLemon(backgroundColor) ? 'lemon' : 'poppy'}
              setCurrentSlide={setCurrentSlide}
              totalSlides={slides.length}
            />
          ) : undefined}
          {...slides[currentSlide]}
        />
      </div>
    </div>
  );
};

export default BlogHero;
